import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

// Wrapper component to provide translation context
const ErrorBoundaryWrapper = ({ children }) => {
  const { t } = useLanguage();
  
  return (
    <ErrorBoundary t={t}>
      {children}
    </ErrorBoundary>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('Error caught by boundary:', error, errorInfo);
    }
    
    // Update state with error details
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    const { t } = this.props;
    
    // Check if current language is RTL
    const currentLanguage = localStorage.getItem('language') || 'en';
    const isRTL = ['he', 'ar'].includes(currentLanguage);

    if (this.state.hasError) {
      // Fallback UI when an error occurs
      return (
        <div className="error-boundary" dir={isRTL ? 'rtl' : 'ltr'} style={{ 
          textAlign: 'center', 
          padding: '2rem', 
          maxWidth: '600px', 
          margin: '2rem auto',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <h2>{t('error')}</h2>
          <p>{t('unexpectedError')}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="btn btn-primary"
            style={{ marginTop: '1rem' }}
          >
            {t('tryAgain')}
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{ marginTop: '1rem', textAlign: isRTL ? 'right' : 'left' }}>
              <summary style={{ cursor: 'pointer', color: '#6c757d' }}>
                {t('errorDetailsDevelopment')}
              </summary>
              <pre style={{
                backgroundColor: '#f8f9fa',
                padding: '1rem',
                borderRadius: '4px',
                overflow: 'auto',
                fontSize: '0.875rem',
                color: '#dc3545'
              }}>
                {this.state.error && this.state.error.toString()}
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundaryWrapper; 